/**
 * Role IDs for role-based access control.
 * Use these constants for conditional rendering and permission checks.
 *
 * ROLE_001 - SuperAdmin (admin panel)
 * ROLE_002 - Organization Admin (admin panel)
 * ROLE_003 - Mentor (member app)
 * ROLE_004 - Intern / Learner (member app)
 * ROLE_005 - Patner (member app)
 */
export const ROLE_001 = "001"; // SuperAdmin
export const ROLE_002 = "002"; // Organization Admin
export const ROLE_003 = "003"; // Mentor
export const ROLE_004 = "004"; // Intern / Learner
export const ROLE_005 = "005"; // Patner

export const ROLE_IDS = {
  SUPER_ADMIN: ROLE_001,
  ORG_ADMIN: ROLE_002,
  MENTOR: ROLE_003,
  INTERN: ROLE_004,
  PATNER: ROLE_005,
};

/** Map role name from backend to role ID */
export const ROLE_NAME_TO_ID = {
  SuperAdmin: ROLE_001,
  "Organization Admin": ROLE_002,
  Mentor: ROLE_003,
  Intern: ROLE_004,
  Learner: ROLE_004,
  Patner: ROLE_005,
};

export const isMentor = (roleId) => roleId === ROLE_003;
export const isIntern = (roleId) => roleId === ROLE_004;
export const isAdmin = (roleId) => roleId === ROLE_001 || roleId === ROLE_002;

